module.exports = __webpack_public_path__ + "static/media/plusIcon.1d4f151b.svg";